import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLicenseList } from "../../api/redux";
import { Formik } from "formik";
import {
  getAllActivityGroup,
  getAllProduct,
  getAllSubSector,
} from "../../api/crud";
import { Select } from "antd";

const { Option } = Select;

export default (props) => {
  const [subSectors, setSubSectors] = useState();
  const [activityGroups, setActivityGroups] = useState(null);
  const [products, setProducts] = useState(null);
  const state = useSelector(selectLicenseList);
  const sectorChangeHandler = async (e, a) => {
    const params = { sectorId: a.value };
    const response = await getAllSubSector(params);
    setSubSectors(response.data.data);
  };
  const dispatch = useDispatch();
  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      onSubmit={(values) => {
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => {
        return (
          <div className="d-flex flex-wrap col-12 mt-3 mb-1">
            <div className="col-12 col-md-6">
              <Select
                size={"large"}
                className="w-100 search-fields"
                placeholder="انتخاب بخش"
                onSelect={(e, a) => {
                  sectorChangeHandler(e, a);
                  setFieldValue("sectorId", e);
                }}
                allowClear
                onClear={(e) => {
                  setFieldValue("subSectorId", null);
                  setFieldValue("sectorId", null);
                  setFieldValue("activityGroupId", null);
                  setFieldValue("productId", null);
                  setProducts(null);
                  setSubSectors(null);
                  setActivityGroups(null);
                }}
                direction="rtl"
                showArrow={true}
                value={values?.sectorId}
                key={5}
              >
                {state.sectors &&
                  state.sectors.map((el) => {
                    return <Option className="text-right" value={el.id}>{el.title}</Option>;
                  })}
              </Select>
            </div>
            <div className="col-12 col-md-6">
              {" "}
              <Select
                className="w-100 search-fields"
                size="large"
                placeholder={"انتخاب زیربخش"}
                showArrow={true}
                direction="rtl"
                allowClear
                key={6}
                value={values?.subSectorId}
                onSelect={(e) => {
                  setFieldValue("subSectorId", e);
                  getAllActivityGroup({ subSectorId: e }).then((res) => {
                    setActivityGroups(res.data.data);
                  });
                }}
                onClear={(e) => {
                  setFieldValue("subSectorId", null);
                  setFieldValue("activityGroupId", null);
                  setFieldValue("productId", null);
                  setActivityGroups(null);
                  setProducts(null);
                }}
              >
                {subSectors &&
                  subSectors.map((el) => {
                    return <Option className="text-right" value={el.id}>{el.title}</Option>;
                  })}
              </Select>
            </div>
            <div className="col-12 col-md-6">
              {" "}
              <Select
                className="w-100 search-fields"
                size="large"
                placeholder={"انتخاب گروه فعالیت"}
                showArrow={true}
                direction="rtl"
                allowClear
                key={6}
                value={values?.activityGroupId}
                onSelect={(e) => {
                  setFieldValue("activityGroupId", e);
                  getAllProduct({ activityGroupId: e }).then((res) => {
                    setProducts(res.data.data);
                  });
                }}
                onClear={(e) => {
                  setProducts(null);
                  setFieldValue("activityGroupId", null);
                  setFieldValue("productId", null);
                }}
              >
                {activityGroups &&
                  activityGroups.map((el) => {
                    return <Option className="text-right" value={el.id}>{el.title}</Option>;
                  })}
              </Select>
            </div>
            <div className="col-12 col-md-6">
              {" "}
              <Select
                className="w-100 search-fields"
                size="large"
                placeholder={"انتخاب محصول"}
                showArrow={true}
                direction="rtl"
                allowClear
                key={6}
                value={values?.productId}
                onSelect={(e) => {
                  props.setProductId(e);
                  setFieldValue("productId", e);
                }}
                onClear={(e) => {
                  props.setProductId(null);
                  setFieldValue("productId", null);
                }}
              >
                {products &&
                  products.map((el) => {
                    return <Option className="text-right" value={el.id}>{el.title}</Option>;
                  })}
              </Select>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};
